import { DeleteOutlined } from '@ant-design/icons'
import { ChangeEvent, useEffect, useState } from 'react'
import { ContactWithId } from '../../../entities'
import { phoneFormat } from '../../../utils/format/phoneFormat'
import { handleChange } from '../../../utils/handleChange'
import { validateEmail } from '../../../utils/validators/validateEmail'
import { colors } from '../../theme'
import { Col } from '../Col'
import { Input } from '../Input'
import { TextArea } from '../TextArea'

type ContactFormProps = {
  value: ContactWithId
  setValue: any
}

export const ContactForm = (props: ContactFormProps) => {
  const { value, setValue } = props
  const [errors, setErrors] = useState<any>({ email: '' })

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue((prev: ContactWithId) => ({
      ...prev,
      phoneNumber: phoneFormat(e.target.value)
    }))
  }

  const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue((prev: ContactWithId) => ({
      ...prev,
      cellNumber: phoneFormat(e.target.value)
    }))
  }

  useEffect(() => {
    if (value.email !== '' && !validateEmail(value.email))
      setErrors((prev: any) => ({
        ...prev,
        email: 'Insira um formato de email válido!'
      }))
    if (validateEmail(value.email))
      setErrors((prev: any) => ({ ...prev, email: '' }))
  }, [value.email])

  return (
    <>
      <Col>
        <Input
          label="Nome"
          value={value.name}
          onChange={(e) => handleChange(e, 'name', setValue)}
        />
      </Col>
      <Col>
        <Input
          label="Função/Cargo"
          value={value.role}
          onChange={(e) => handleChange(e, 'role', setValue)}
        />
      </Col>
      <Col>
        <Input
          label="Telefone 1"
          value={value.phoneNumber}
          onChange={handlePhoneChange}
        />
      </Col>
      <Col>
        <Input
          label="Telefone 2"
          value={value.cellNumber}
          onChange={handleMobileChange}
        />
      </Col>
      <Col>
        <Input
          label="E-mail"
          type="email"
          value={value.email}
          onChange={(e) => handleChange(e, 'email', setValue)}
          error={errors.email}
        />
      </Col>
      <Col>
        <TextArea
          label="Observação"
          rows={4}
          value={value.observation}
          onChange={(e: any) => handleChange(e, 'observation', setValue)}
        />
      </Col>
    </>
  )
}

type ContactCardProps = {
  edit: any
  remove: any
  state: ContactWithId
}

export const ContactCard = (props: ContactCardProps) => {
  const { state, edit, remove } = props

  return (
    <div
      style={{
        background: 'white',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}
    >
      <div
        style={{
          padding: 10,
          width: '100%',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={() => edit(state.id)}
      >
        <span
          style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 5 }}
        >
          {state.role || 'NÃO INFORMADO'}
        </span>
        <span>{state.name}</span>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: 10
        }}
      >
        <DeleteOutlined
          style={{ color: colors.error }}
          onClick={() => remove(state.id)}
        />
      </div>
    </div>
  )
}
